<!-- =========================================================================================
  File Name: UserEdit.vue
  Description: User Edit Page
  ---------------------------------------------------------------------
  -------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="page-user-edit">
     
      <vx-card>
      
        <div slot="no-body" class="tabs-container px-6 pt-6">
  
          <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
            <vs-tab label="Conta" icon-pack="feather" icon="icon-user">
              <div class="tab-text">
                <div id="user-edit-tab-info">
  
                <!-- Avatar Row -->
                <div class="vx-row mb-5">
                    <div class="vx-col w-full">
                      <div class="flex items-start flex-col sm:flex-row">
                        <img v-if="employee.user.image" class="mr-8 rounded h-24 w-24" :src="employee.user.image"
                          size="80px" />
                        <i v-else class="fad fa-user-circle fa-5x ml-2 mr-8 text-primary"></i>
                        <div>
                          <p class="text-lg font-medium mb-2 mt-4 sm:mt-0"></p>
                          <!-- <vs-input type="file" ref="update_avatar_input"   name="imagem"  @change="fileImageProfile" accept="image/*">
              
                </vs-input> -->
                          <!-- Toggle comment of below buttons as one for actual flow & currently shown is only for demo -->
                          <!-- <vs-button :disabled="!canUpdateEmp" class="mr-4 mb-4"  @click="$refs.update_avatar_input.click()">Carregar foto</vs-button> -->
                          <!-- <vs-button type="border" class="mr-4" @click="$refs.update_avatar_input.click()">Change Avatar</vs-button> -->
  
  
  
                          <input disabled type="file" ref="fileInput" style="display: none" name="imagem" @change="fileImageProfile">
                          <vs-button disabled class="mr-4 mb-4" @click="$refs.fileInput.click()">Carregar foto</vs-button>
                          <vs-button v-if="imagem !== ''" type="border" size="small" color="primary"
                            @click="saveProfilePicture">
  
                            <i class="fas fa-sync fa-2x"></i>
  
  
                          </vs-button>
                          <p v-if="processarFoto == false" class="text-sm mt-2">Formatos suportados JPG, JPEG or PNG.</p>
                          <p v-if="processarFoto == true"> <vs-progress indeterminate color="primary"></vs-progress></p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="vx-row">
                    <!-- VERTICAL LAYOUT WITH ICON-->
                    <div class="vx-col w-full mb-base">
                      <div class="vx-row">
                        <div class="vx-col sm:w-1/2 w-full mb-2">
                          <label class="text-sm font-bold">Nome</label>
                          <div class="vx-col w-full">
                            <vs-input disabled class="w-full" icon-pack="feather" icon="icon-user" icon-no-border
                              v-model="employee.user.name" />
                          </div>
                        </div>
                        <div class="vx-col sm:w-1/2 w-full mb-2">
                          <label class="text-sm font-bold">Apelido</label>
                          <div class="vx-col w-full">
                            <vs-input disabled class="w-full" icon-pack="feather" icon="icon-user" icon-no-border
                              v-model="employee.user.surname" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-row">
                        <div class="vx-col sm:w-1/2 w-full mb-2">
                          <label class="text-sm font-bold">Telefone</label>
                          <div class="vx-col w-full">
                            <vs-input disabled class="w-full" icon-pack="feather" icon="icon-smartphone" icon-no-border
                              v-model="employee.contacts.phone" type="number" />
                          </div>
                        </div>
                        <div class="vx-col sm:w-1/2 w-full mb-2">
                          <label class="text-sm font-bold">Email</label>
                          <div class="vx-col w-full">
                            <vs-input disabled type="email" class="w-full" icon-pack="feather" icon="icon-mail" icon-no-border
                              v-model="employee.user.email" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-row">
                        <div class="vx-col sm:w-1/2 w-full mb-2">
                          <div class="vx-col w-full">
                            <label class="text-sm font-bold">Data de Nascimento</label>
                            <vs-input disabled class="w-full" icon-pack="feather" icon-no-border v-model="employee.birth_date"
                              type="date" />
  
                          </div>
                        </div>
                        <div class="vx-col sm:w-1/2 w-full mb-2">
  
                          <div class="vx-col w-full">
                            <label class="text-sm font-bold">Gênero</label>
                            <div class="mt-2">
                              <vs-radio disabled v-model="employee.gender" vs-value="Masculino" class="mr-4">Masculino</vs-radio>
                              <vs-radio disabled v-model="employee.gender" vs-value="Feminino" class="mr-4">Feminino</vs-radio>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-row">
                        <div class="vx-col sm:w-1/2 w-full mb-2">
                          <div class="vx-col w-full">
  
                            <label class="text-sm font-bold">Estado Civil</label>
  
                            <select disabled
                              class="block w-full pl-3 pr-10 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed"
                              v-validate="'excluded:1,2,3'" v-model="employee.marital_status" name="not_in_field"
                              data-vv-as="selected">
                              <option value="1">Solteiro(a)</option>
                              <option class="vs__selected-options" value="2">Casado(a)</option>
                              <option class="vs__selected-options" value="3">Divorciado(a)</option>
                              <option class="vs__selected-options" value="4">Viúvo(a)</option>
                            </select>
  
                          </div>
                        </div>
                        <div class="vx-col sm:w-1/2 w-full mb-2">
                          <label class="text-sm font-bold">Endereço</label>
                        <div class="vx-col w-full">
                          <vs-input disabled class="w-full" icon-pack="feather" icon="icon-map-pin" icon-no-border
                            v-model="employee.address" />
                        </div>
                      </div>
                    </div>
                    <div class="vx-row">
                      <div class="vx-col sm:w-1/2 w-full mb-2">
                        <div class="vx-col w-full">
                          <!-- Nacionalidade
  
                  <ul class="centerx">
                    <li>
                      <vs-radio v-model="type" vs-value="BI">Mocambicana</vs-radio>
                    </li>
                    <li>
                      <vs-radio v-model="type" vs-value="DIRE"
                        >Estrangeira</vs-radio
                      >
                    </li>
                  </ul> -->
  
                            <div class="vx-col w-full">
                              <label class="text-sm font-bold">Nacionalidade</label>
                              <div class="mt-2">
                                <vs-radio disabled v-model="employee.document_type" vs-value="BI" class="mr-4">Mocambicana</vs-radio>
                                <vs-radio disabled v-model="employee.document_type" vs-value="DIRE"
                                  class="mr-4">Estrangeira</vs-radio>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="vx-col sm:w-1/2 w-full mb-2">
                          <div class="vx-col w-full">
                            <div class="vx-col w-full">
                              <label class="text-sm font-bold">Pais</label>
                              <v-select disabled 
                                v-model="employee.nationality" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-row">
                        <div class="vx-col sm:w-1/2 w-full mb-2">
                          <div class="vx-col w-full" v-if="employee.document_type == 'BI'">
                            <label class="text-sm font-bold">Tipo de documento</label> <br />
                            <span>Bilhete de Identidade</span>
  
                          </div>
                          <div class="vx-col w-full" v-else>
                            <v-select disabled v-model="employee.document_type" :options="['DIRE', 'PASSAPORTE']"> </v-select>
  
                          </div>
                        </div>
  
  
  
                        <div class="vx-col sm:w-1/2 w-full mb-2">
                          <div class="vx-col w-full">
                            <label class="text-sm font-bold">Número do documento</label>
                            <vs-input disabled class="w-full" icon-pack="feather" icon="icon-hash" icon-no-border
                              v-model="employee.document_number" />
                          </div>
                        </div>
  
                      </div>
  
  
  
                      <div class="vx-row">
                        <div class="vx-col sm:w-1/2 w-full mb-2">
                          <label class="text-sm font-bold">NUIT</label>
                          <div class="vx-col w-full">
                            <vs-input disabled class="w-full" icon-pack="feather" icon-no-border v-model="employee.nuit"
                              type="number" />
                        </div>
                      </div>
                      <div class="vx-col sm:w-1/2 w-full mb-2">
                        <div class="vx-col w-full">
                          <label class="text-sm font-bold">INSS</label>
                          <vs-input disabled class="w-full" icon-pack="feather" icon-no-border v-model="employee.inss"
                            type="number" />
                        </div>
                      </div>
                      <!-- <div class="vx-col sm:w-1/2 w-full mb-2">
              <div class="vx-col w-full">
                   <label class="text-sm font-bold">Numero de Dependentes</label>
                  <vs-input
                    class="w-full"
                    icon-pack="feather"
                    icon-no-border
                    v-model="employee.dependent"
                    type="number"
                  />
                </div>
              </div> -->
                      </div>
  
                      <div class="vx-row">
                        <div class="vx-col sm:w-1/2 w-full mb-2">
                          <div class="vx-col w-full">
                            <label class="text-sm font-bold">Departamento</label>
                            <v-select disabled label="name" :options="departments" v-model="selectedDepartment" />
  
  
                          </div>
                        </div>
                        <div class="vx-col sm:w-1/2 w-full mb-2">
                          <div class="vx-col w-full">
  
                            <label class="text-sm font-bold">Função</label>
                            <v-select  disabled label="name" :options="company_roles" v-model="selectedPosition" />
  
  
                          </div>
                        </div>
                      </div>
                      <div class="vx-row">
                        <div class="vx-col sm:w-1/2 w-full mb-2">
                          <div class="vx-col w-full">
                            <label class="text-sm font-bold">Salário Base</label>
                            <vx-input-group class="mb-base">
                              <vs-input disabled min="0" type="number" v-model="employee.basic_salary" />
  
                              <template slot="append">
                                <div class="append-text bg-primary">
                                  <span>.MT</span>
                                </div>
                              </template>
                            </vx-input-group>
                          </div>
                        </div>
  
                      </div>
  
  
  
  
                     
                      <p> <vs-progress v-if="process == true" indeterminate color="primary"></vs-progress></p>
  
                      <!-- CODE -->
                    </div>
                  </div>
                </div>
              </div>
            </vs-tab>
            <vs-tab label="Subsídios" icon-pack="feather" icon="icon-dollar-sign">
              <div class="tab-text">
                <vs-table search stripe :data="structure_components">
  
                  <template slot="thead">
                    <vs-th sort-key="name">Nome</vs-th>
                    <vs-th sort-key="name">Abreviatura</vs-th>
                  <vs-th sort-key="name">Valor</vs-th>
                  <vs-th></vs-th>
  
  
                  <!-- <vs-th sort-key="birth_date">Data de Nascimento</vs-th> -->
                  <!-- <vs-th sort-key="id">Nro</vs-th> -->
                </template>
  
                <template slot-scope="{data}">
            
  
                    <vs-tr v-for="data in structure_components" :key="document.id">
                      <template v-if="data.abbreviation != 'INSS' && data.abbreviation != 'IRPS'">
                        <vs-td>{{ data.name }}</vs-td>
                        <vs-td>{{ data.abbreviation }}</vs-td>
  
                        <vs-td>
                          {{ data.pivot.amount }}
                        </vs-td>
  
                        <vs-td class="whitespace-no-wrap">
                         
                        </vs-td>
                      </template>
  
  
                    </vs-tr>
                  </template>
                </vs-table>
                <div style="height: 50px;" id="div-with-loading" class="vs-con-loading__container"></div>
  
  
            
              </div>
  
              <vs-tabs>
  
  
  
  
  
              </vs-tabs>
  
  
  
              <vs-popup class="holamundo" title="Renovações anteriores" :active.sync="popupVerRenovacao">
  
                <vs-table stripe :data="contract.renews">
  
                  <template slot="thead">
  
                    <vs-th sort-key="status">Estado</vs-th>
                    <vs-th sort-key="type">Tipo de contrato</vs-th>
                    <vs-th sort-key="start_date">Data de inicio</vs-th>
                    <vs-th sort-key="expiry_date">Data de Término</vs-th>
                    <!-- <vs-th sort-key="id">Nro</vs-th> -->
  
  
                  </template>
  
                  <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td :data="data[indextr].status">
                        {{ data[indextr].status }}
                      </vs-td>
                      <vs-td :data="data[indextr].type">
  
                        <span v-if="data[indextr].type == 1">Prazo Certo</span>
                        <span v-if="data[indextr].type == 2">Prazo Incerto</span>
                        <span v-if="data[indextr].type == 3">Indeterminado</span>
                        <span v-if="data[indextr].type == 4">Estagio</span>
                      </vs-td>
  
                      <vs-td :data="data[indextr].start_date">
                        {{ data[indextr].start_date }}
                      </vs-td>
                      <vs-td :data="data[indextr].expiry_date">
                        {{ data[indextr].expiry_date }}
                      </vs-td>
  
  
                    </vs-tr>
                  </template>
                </vs-table>
  
  
              </vs-popup>
  
  
  
            
  
  
            </vs-tab>
            <vs-tab label="Impostos" icon-pack="feather" icon="icon-dollar-sign">
              <div class="tab-text">
                <vs-table search stripe :data="structure_components">
  
                
                  <template slot="thead">
                    <vs-th sort-key="name">Nome</vs-th>
                    <vs-th sort-key="name">Abreviatura</vs-th>
  
                  <vs-th></vs-th>
  
  
                  <!-- <vs-th sort-key="birth_date">Data de Nascimento</vs-th> -->
                  <vs-th></vs-th>
                  <!-- <vs-th sort-key="id">Nro</vs-th> -->
                </template>
  
                <template slot-scope="{data}">
                  <!-- <vs-tr  :key="indextr" v-for="(tr, indextr) in data">
        
        <vs-td :data="data[indextr].name">
         
          {{ data[indextr].name }}
        </vs-td>
        <vs-td :data="data[indextr].abbreviation">
         
          {{ data[indextr].abbreviation }}
        </vs-td>
         
      
      
        <vs-td :data="data[indextr].pivot.amount">
          <span v-if="data[indextr].abbreviation=='IRPS' || data[indextr].abbreviation=='INSS'">Cálculo automático </span>
         <span v-else>  {{ data[indextr].pivot.amount }}</span>
         
       </vs-td>
    
      
  
      
          <vs-td  :data="data[indextr].id">
            <vs-row>
                        <vs-button :disabled="data[indextr].abbreviation=='INSS' || data[indextr].abbreviation=='IRPS' " color="success" size="small" hover:text-danger type="border" icon-pack="feather" icon="icon-edit"  @click="popupOpenEditComponent(tr)">
  
                        </vs-button>
                        <vs-button class="ml-2" color="danger"  type="border" size="small" icon-pack="feather" icon="icon-trash" @click="openComponentConfirm(tr)"></vs-button>
                 </vs-row>
                </vs-td>
  
        </vs-tr> -->
  
                    <vs-tr v-for="data in structure_components" :key="document.id">
                      <template v-if="data.abbreviation == 'INSS' || data.abbreviation == 'IRPS'">
                        <vs-td>{{ data.name }}</vs-td>
                      <vs-td>{{ data.abbreviation }}</vs-td>
  
                        <vs-td>
  
                        </vs-td>
  
                        <vs-td class="whitespace-no-wrap">
                          <vs-row>
  
                            <!-- <vs-button :disabled="data.abbreviation=='INSS' || data.abbreviation=='IRPS' " color="success" size="small" hover:text-danger type="border" icon-pack="feather" icon="icon-edit"  @click="popupOpenEditComponent(tr)">
  
            </vs-button> -->
                            <vs-button class="ml-2" color="danger" type="border" size="small" icon-pack="feather"
                              icon="icon-trash" @click="openComponentConfirm(data)"></vs-button>
                          </vs-row>
                        </vs-td>
                      </template>
  
  
                    </vs-tr>
  
  
                  </template>
                </vs-table>
                <div style="height: 50px;" id="div-with-loading" class="vs-con-loading__container"></div>
  
  
  
              </div>
  
  
  
  
  
  
  
            </vs-tab>
            <vs-tab label="Contactos" icon-pack="feather" icon="icon-smartphone">
              <div class="tab-text">
                <vs-table stripe search :data="contacts">
             
                  <template stripe slot="thead">
                    <vs-th sort-key="type">Tipo de contacto</vs-th>
                    <vs-th sort-key="phone">Telefone</vs-th>
                    <vs-th></vs-th>
                  </template>
  
                  <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
  
  
  
  
                      <vs-td v-if="data[indextr].type == 1" :data="data[indextr].type">
                        Principal
                      </vs-td>
                      <vs-td v-else :data="data[indextr].type">
                        Alternativo
                      </vs-td>
                      <vs-td :data="data[indextr].phone">
                        {{ data[indextr].phone }}
                      </vs-td>
                      <vs-td>
                       
                      </vs-td>
  
  
                    </vs-tr>
                  </template>
                </vs-table>
  
              </div>
  
  
  
            
  
  
              <vs-popup class="holamundo" title="Renovações anteriores" :active.sync="popupVerRenovacao">
                <vs-table stripe :data="contract.renews">
  
                  <template slot="thead">
  
                    <vs-th sort-key="status">Estado</vs-th>
                    <vs-th sort-key="type">Tipo de contrato</vs-th>
                    <vs-th sort-key="start_date">Data de inicio</vs-th>
                    <vs-th sort-key="expiry_date">Data de Término</vs-th>
                    <!-- <vs-th sort-key="id">Nro</vs-th> -->
  
  
                  </template>
  
                  <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td :data="data[indextr].status">
                        {{ data[indextr].status }}
                      </vs-td>
                      <vs-td :data="data[indextr].type">
  
                        <span v-if="data[indextr].type == 1">Prazo Certo</span>
                        <span v-if="data[indextr].type == 2">Prazo Incerto</span>
                        <span v-if="data[indextr].type == 3">Indeterminado</span>
                        <span v-if="data[indextr].type == 4">Estagio</span>
                      </vs-td>
  
                      <vs-td :data="data[indextr].start_date">
                        {{ data[indextr].start_date }}
                      </vs-td>
                      <vs-td :data="data[indextr].expiry_date">
                        {{ data[indextr].expiry_date }}
                      </vs-td>
  
                    </vs-tr>
                  </template>
                </vs-table>
  
  
              </vs-popup>
  
  
  
  
  
  
  
            </vs-tab>
            <vs-tab label="Contratos" icon-pack="feather" icon="icon-file">
              <div class="tab-text">
                <vs-table stripe search :data="contracts">
                
                  <template stripe slot="thead">
                    <vs-th sort-key="type">Tipo de contrato</vs-th>
                    <vs-th sort-key="start_date">Data de Inicio</vs-th>
                    <vs-th sort-key="expiry_date">Data de termino</vs-th>
                    <vs-th sort-key="renewals_number">Renovações</vs-th>
                    <vs-th sort-key="status">Estado</vs-th>
                    <vs-th sort-key="status">Anexo</vs-th>
                    <vs-th sort-key="status"></vs-th>
  
                  </template>
  
                  <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
  
  
  
                      <vs-td :data="data[indextr].type">
                        <span v-if="data[indextr].type == 1">Prazo Certo</span>
                        <span v-if="data[indextr].type == 2">Prazo Incerto</span>
                        <span v-if="data[indextr].type == 3">Indeterminado</span>
                        <span v-if="data[indextr].type == 4">Estagio</span>
                      </vs-td>
                      <vs-td :data="data[indextr].start_date">
                        {{ data[indextr].start_date }}
                      </vs-td>
                      <vs-td :data="data[indextr].expiry_date">
                        {{ data[indextr].expiry_date }}
                      </vs-td>
                      <vs-td :data="data[indextr].renewals_number">
                        {{ data[indextr].renewals_number }}
                      </vs-td>
                      <vs-td :data="data[indextr].status">
                        {{ data[indextr].status }}
                      </vs-td>
                      <vs-td class="whitespace-no-wrap" :data="data[indextr].attachment">
                        <a :href="data[indextr].attachment" download target="_blank"> <i class="fa fa-download"></i>
                          Baixar</a>
                      </vs-td>
                    
                      
                      <vs-td class="whitespace-no-wrap" :data="data[indextr].id">
                        <vs-row>
                          <vs-button  color="primary" type="border" size="small"
                            @click="popupVerRenovacoes(tr)">
                            <i class="fa fa-eye"></i>
                          </vs-button>
  
                        </vs-row>
                      </vs-td>
  
  
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
  
             
  
  
  
              <vs-popup class="holamundo" title="Renovações anteriores" :active.sync="popupVerRenovacao">
                <vs-table stripe :data="contract.renews">
  
                  <template slot="thead">
  
                    <vs-th sort-key="status">Estado</vs-th>
                    <vs-th sort-key="type">Tipo de contrato</vs-th>
                    <vs-th sort-key="start_date">Data de inicio</vs-th>
                    <vs-th sort-key="expiry_date">Data de Termino</vs-th>
                    <!-- <vs-th sort-key="id">Nro</vs-th> -->
  
  
                  </template>
  
                  <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td :data="data[indextr].status">
                        {{ data[indextr].status }}
                      </vs-td>
                      <vs-td :data="data[indextr].type">
  
                        <span v-if="data[indextr].type == 1">Prazo Certo</span>
                        <span v-if="data[indextr].type == 2">Prazo Incerto</span>
                        <span v-if="data[indextr].type == 3">Indeterminado</span>
                        <span v-if="data[indextr].type == 4">Estagio</span>
                      </vs-td>
  
                      <vs-td :data="data[indextr].start_date">
                        {{ data[indextr].start_date }}
                      </vs-td>
                      <vs-td :data="data[indextr].expiry_date">
                        {{ data[indextr].expiry_date }}
                      </vs-td>
  
                    </vs-tr>
                  </template>
                </vs-table>
  
  
              </vs-popup>
  
             
            </vs-tab>
  
  
  
          </vs-tabs>
  
        </div>
  
      </vx-card>
      <vx-card class="mt-5">
        <vs-collapse type="margin" accordion>
  
          <vs-collapse-item>
  
  
  
  
            <div slot="header">
              <h4 class="text-primary ">
                <i class="fas fa-books mr-4"></i>
                Documentos (Anexos)
              </h4>
            </div>
  
            <vx-card no-shadow>
  
  
  
              <vs-tabs>
                <vs-tab label="Documentos Pessoais">
                  <div class="tab-text mt-5">
                    <vs-table stripe :data="documents">
                      <vs-th>Nome</vs-th>
                      <vs-th>Numero</vs-th>
                      <vs-th>Data de emissão</vs-th>
                      <vs-th>Válido ate</vs-th>
                      <vs-th>Download</vs-th>
  
                      <vs-tr v-for="document in documents" :key="document.id">
                        <template v-if="document.type === '1'">
                          <vs-td>{{ document.name }}</vs-td>
                          <vs-td>{{ document.number }}</vs-td>
                          <vs-td>{{ document.issue_date }}</vs-td>
                          <vs-td>{{ document.expiry_date }}</vs-td>
                          <vs-td>
                            <a :href="document.attachment" download target="_blank"> <i class="fa fa-download"></i>
                              DOWNLOAD</a>
  
                          </vs-td>
  
                          <vs-td class="whitespace-no-wrap">
                           
                          </vs-td>
                        </template>
  
  
                      </vs-tr>
  
  
                    </vs-table>
                  </div>
                </vs-tab>
  
  
                <vs-tab label="Adendas">
                  <div class="tab-text mt-5">
                    <vs-table stripe :data="documents">
                      <vs-th>Nome</vs-th>
                      <vs-th>Número</vs-th>
                      <vs-th>Data de emissão</vs-th>
                      <vs-th>Válido até</vs-th>
                      <vs-th>Download</vs-th>
  
                      <vs-tr v-for="document in documents" :key="document.id">
                        <template v-if="document.type === '3'">
                          <vs-td>{{ document.name }}</vs-td>
                          <vs-td>{{ document.number }}</vs-td>
                          <vs-td>{{ document.issue_date }}</vs-td>
                          <vs-td>{{ document.expiry_date }}</vs-td>
                          
                          <vs-td>
                            <a :href="document.attachment" download target="_blank"> <i class="fa fa-download"></i>
                              DOWNLOAD</a>
  
                          </vs-td>
  
                          <vs-td class="whitespace-no-wrap">
                          
                          </vs-td>
                        </template>
  
  
                      </vs-tr>
  
  
                    </vs-table>
                  </div>
                </vs-tab>
                <vs-tab label="Outros">
                  <div class="tab-text mt-5">
                    <vs-table stripe :data="documents">
                      <vs-th>Nome</vs-th>
                      <vs-th>Número</vs-th>
                      <vs-th>Válido até</vs-th>
                      <vs-th>Download</vs-th>
  
                      <vs-tr v-for="document in documents" :key="document.id">
                        <template v-if="document.type === '4'">
                          <vs-td>{{ document.name }}</vs-td>
                          <vs-td>{{ document.number }}</vs-td>
                          <vs-td>{{ document.expiry_date }}</vs-td>
                          <vs-td>
                            <a :href="document.attachment" download target="_blank"> <i class="fa fa-download"></i>
                              DOWNLOAD</a>
  
                          </vs-td>
  
                          <vs-td class="whitespace-no-wrap">
                            
                          </vs-td>
                        </template>
  
  
                      </vs-tr>
  
  
                    </vs-table>
                  </div>
                </vs-tab>
              </vs-tabs>
  
  
              
            </vx-card>
          </vs-collapse-item>
        
        <vs-collapse-item>
          <div slot="header">
    <h4 class="text-primary ">
      <i class="fad fa-file mr-4"></i>
      Processos
    </h4>
    </div>
    
  
                
            
                <vs-tabs>
                <vs-tab label="Adomestacão">
                  <div class="tab-text mt-5">
                    <vs-table stripe :data="processos">
                      <vs-th>Tipo</vs-th>
                      <vs-th>Infracção</vs-th>
                      <vs-th>Data de inicio</vs-th>
                      <vs-th>Data de termino</vs-th>
                      <vs-th>Documento</vs-th>
  
                      <vs-tr v-for="processo in processesList" :key="processo.id">
                        <template v-if="processo.type === 'adomestacao'">
                          <vs-td>{{ processo.type }}</vs-td>
                          <vs-td>{{ processo.description }}</vs-td>
                          <vs-td>{{ processo.start_date }}</vs-td>
                          <vs-td>{{ processo.end_date }}</vs-td>
                          <vs-td>
                            <a :href="processo.attachment" download target="_blank"> <i class="fa fa-download"></i>
                              DOWNLOAD</a>
                          </vs-td>
  
                          <vs-td class="whitespace-no-wrap">
                           
                          </vs-td>
                        </template>
  
  
                      </vs-tr>
  
  
                    </vs-table>
                  </div>
                </vs-tab>
  
  
                <vs-tab label="Repreensão">
                  <div class="tab-text mt-5">
                    <vs-table stripe>
                      <vs-th>Tipo</vs-th>
                      <vs-th>Infracção</vs-th>
                      <vs-th>Data de inicio</vs-th>
                      <vs-th>Data de termino</vs-th>
                      <vs-th>Documento</vs-th>
  
                      <vs-tr v-for="processo in processesList" :key="processo.id">
                        <template v-if="processo.type === 'repreensao'">
                          <vs-td>{{ processo.type }}</vs-td>
                          <vs-td>{{ processo.description }}</vs-td>
                          <vs-td>{{ processo.start_date }}</vs-td>
                          <vs-td>{{ processo.end_date }}</vs-td>
                          <vs-td>
                            <a :href="processo.attachment" download target="_blank"> <i class="fa fa-download"></i>
                              DOWNLOAD</a>
  
                          </vs-td>
  
                          <vs-td class="whitespace-no-wrap">
                            
                          </vs-td>
                        </template>
  
  
                      </vs-tr>
  
  
                    </vs-table>
                  </div>
                </vs-tab>
                <vs-tab label="Processo disciplinar">
                  <div class="tab-text mt-5">
                    <vs-table stripe>
                      <vs-th>Tipo</vs-th>
                      <vs-th>Infracção</vs-th>
                      <vs-th>Data de inicio</vs-th>
                      <vs-th>Data de termino</vs-th>
                      <vs-th>Documento</vs-th>
  
                      <vs-tr v-for="processo in processesList" :key="processo.id">
                        <template v-if="processo.type === 'disciplinar'">
                          <vs-td>{{ processo.type }}</vs-td>
                          <vs-td>{{ processo.description }}</vs-td>
                          <vs-td>{{ processo.start_date }}</vs-td>
                          <vs-td>{{ processo.end_date }}</vs-td>
                          <vs-td>
                            <a :href="processo.attachment" download target="_blank"> <i class="fa fa-download"></i>
                              DOWNLOAD</a>
  
                          </vs-td>
  
                          <vs-td class="whitespace-no-wrap">
                           
                          </vs-td>
                        </template>
  
  
                      </vs-tr>
  
  
                    </vs-table>
                  </div>
                </vs-tab>
              </vs-tabs>
  
        </vs-collapse-item> 
    <!-- ////////////////////////////////////////////////////? -->
          <vs-collapse-item>
  
            <div slot="header">
              <h4 class="text-primary ">
                <i class="fad fa-briefcase mr-4"></i>
                Experiência de Trabalho
              </h4>
            </div>
  
            <vx-card no-shadow>
  
  
              <div class="flex flex-wrap items-center justify-end">
  
  
              </div>
  
              <vs-table search stripe :data="work_experiences">
              
                <template slot="thead">
                  <vs-th sort-key="company_name">Nome da empresa</vs-th>
                  <vs-th sort-key="address">Endereço</vs-th>
                  <vs-th sort-key="position">Função</vs-th>
                  <vs-th sort-key="start_date">Data de início</vs-th>
                  <vs-th sort-key="end_date">Data de término</vs-th>
                  <vs-th></vs-th>
                </template>
  
                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].company_name">
                      {{ data[indextr].company_name }}
                    </vs-td>
  
  
  
                    <vs-td :data="data[indextr].address">
                      {{ data[indextr].address }}
                    </vs-td>
  
                    <vs-td :data="data[indextr].position">
                      {{ data[indextr].position }}
                    </vs-td>
  
                    <vs-td :data="data[indextr].start_date">
                      {{ data[indextr].start_date }}
                    </vs-td>
  
                    <vs-td :data="data[indextr].end_date">
                      {{ data[indextr].end_date }}
                    </vs-td>
                    <vs-td class="whitespace-no-wrap" :data="data[indextr].id">
                    
                    </vs-td>
  
  
                  </vs-tr>
                </template>
              </vs-table>
  
            
            </vx-card>
          </vs-collapse-item>
  
  
          <vs-collapse-item>
  
            <div slot="header">
              <h4 class="text-primary ">
                <i class="fad fa-graduation-cap mr-4"></i>
                Formação Acadêmica
              </h4>
            </div>
  
            <vx-card no-shadow>
  
  
              <div class="flex flex-wrap items-center justify-end">
  
  
              </div>
              <vs-table search stripe :data="educations">
                
                <template slot="thead">
                  <vs-th sort-key="school_name">Instituição de ensino</vs-th>
                  <vs-th sort-key="level">Nível</vs-th>
                  <vs-th sort-key="course">Formação</vs-th>
                  <vs-th sort-key="conclusion_year">Data de Conclusão</vs-th>
                  <vs-th></vs-th>
                  <!-- <vs-th sort-key="id">Nro</vs-th> -->
                </template>
  
                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].school_name">
                      {{ data[indextr].school_name }}
                    </vs-td>
  
                    <vs-td :data="data[indextr].level">
                      {{ data[indextr].level }}
                    </vs-td>
                    <vs-td :data="data[indextr].course">
                      {{ data[indextr].course }}
                    </vs-td>
  
                    <vs-td :data="data[indextr].conclusion_year">
                      {{ data[indextr].conclusion_year }}
                    </vs-td>
  
  
                    <vs-td class="whitespace-no-wrap" :data="data[indextr].id">
                      <vs-row>
                      
                      </vs-row>
                      <!-- <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" /> -->
                    </vs-td>
  
                    <!-- <vs-td :data="data[indextr].id">
            {{ data[indextr].id }}
          </vs-td> -->
                  </vs-tr>
                </template>
              </vs-table>
  
            
  
  
            </vx-card>
          </vs-collapse-item>
  
  
          <vs-collapse-item>
  
            <div slot="header">
              <h4 class="text-primary ">
                <i class="fad fa-child mr-4"></i>
                Dependentes
              </h4>
            </div>
  
            <vx-card no-shadow>
  
  
              <div class="flex flex-wrap items-center justify-end">
  
  
              </div>
              <vs-table search stripe :data="dependents">
             
                <template slot="thead">
                  <vs-th sort-key="name">Nome</vs-th>
                  <vs-th sort-key="kinship">Grau de parentesco</vs-th>
                  <vs-th sort-key="birth_date">Data de Nascimento</vs-th>
                  <vs-th sort-key="doc_type">Tipo de documento</vs-th>
                  <vs-th sort-key="doc_number">Nr. do documento</vs-th>
                  <vs-th></vs-th>
                  <!-- <vs-th sort-key="id">Nro</vs-th> -->
                </template>
  
                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].name">
                      {{ data[indextr].name }}
                    </vs-td>
                    <vs-td :data="data[indextr].dependenteGrau">
                      {{ data[indextr].kinship }}
                    </vs-td>
  
                    <vs-td :data="data[indextr].birth_date">
                      {{ data[indextr].birth_date }}
                    </vs-td>
                    <vs-td :data="data[indextr].doc_type">
                      {{ data[indextr].doc_type }}
                    </vs-td>
                    <vs-td :data="data[indextr].type">
                      {{ data[indextr].doc_number }}
                    </vs-td>
  
  
  
  
  
                    <vs-td class="" :data="data[indextr].id">
                      <vs-row>
                    
                      </vs-row>
                      <!-- <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" /> -->
                    </vs-td>
  
                    <!-- <vs-td :data="data[indextr].id">
            {{ data[indextr].id }}
          </vs-td> -->
                  </vs-tr>
                </template>
              </vs-table>
  
            </vx-card>
          </vs-collapse-item>
  
  
          <vs-collapse-item>
  
            <div slot="header">
              <h4 class="text-primary ">
                <i class="fad fa-wheelchair mr-4"></i>
                Deficiências
              </h4>
            </div>
  
            <vx-card no-shadow>
  
  
              <div class="flex flex-wrap items-center justify-end">
  
  
              </div>
              <vs-table search stripe :data="deficiencies">
              
                <template slot="thead">
                  <vs-th sort-key="description">Tipo</vs-th>
                  <vs-th sort-key="description">Descrição</vs-th>
                  <vs-th></vs-th>
                </template>
  
                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].type">
                      {{ data[indextr].type }}
                    </vs-td>
                    <vs-td :data="data[indextr].description">
                      {{ data[indextr].description }}
                    </vs-td>
  
  
                    <vs-td class="whitespace-no-wrap" :data="data[indextr].id">
                      
                    
                      <!-- <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" /> -->
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
  
             
  
            </vx-card>
          </vs-collapse-item>
  
  
  
  
  
          <vs-collapse-item>
  
  
            <div slot="header">
              <h4 class="text-primary ">
                <i class="fad fa-users mr-4"></i>
                Agregado Familiar
              </h4>
            </div>
  
            <vx-card no-shadow>
  
  
              <div class="flex flex-wrap items-center justify-end">
  
  
              </div>
              <vs-table search stripe :data="households">
              
                <template slot="thead">
                  <vs-th sort-key="name">Nome</vs-th>
                  <vs-th sort-key="kinship">Grau de parentesco</vs-th>
                  <vs-th sort-key="doc_number">Telefone</vs-th>
                  <vs-th></vs-th>
                  <!-- <vs-th sort-key="id">Nro</vs-th> -->
                </template>
  
                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].name">
                      {{ data[indextr].name }}
                    </vs-td>
  
                    <vs-td :data="data[indextr].kinship">
                      {{ data[indextr].kinship }}
                    </vs-td>
  
                    <vs-td :data="data[indextr].cell">
                      {{ data[indextr].cell }}
                    </vs-td>
  
  
  
  
                    <vs-td class="whitespace-no-wrap" :data="data[indextr].id">
                      <vs-td class="whitespace-no-wrap" :data="data[indextr].id">
                      
                        <!-- <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" /> -->
                      </vs-td>
                      <!-- <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" /> -->
                    </vs-td>
  
                    <!-- <vs-td :data="data[indextr].id">
            {{ data[indextr].id }}
          </vs-td> -->
                  </vs-tr>
                </template>
              </vs-table>
  
            </vx-card>
          </vs-collapse-item>
  
  
  
      </vs-collapse>
      </vx-card>
     
   
    </div>
  </template>
  
  <script>
  
  // import Documents from "./Documents.vue"
  import http from "../../../../http-common"
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import vSelect from 'vue-select'
  import { PermissionsMixin } from "../../../mixins/permissions"
  
  export default {
    mixins: [PermissionsMixin],
    components: {
      flatPickr,
      vSelect
    },
    data() {
      return {
        userId:"",
        nrRenovacoes:0,
        process:[],
        processarFoto:false,
        component: [
          {
            id: '',
            amount: '',
            selectedComponent: '',
          }
        ],
        popupAddImposto: false,
        popupAddSubsidio: false,
        document: [
  
        ],
        novoContacto: "",
        contacto: [
          {
            phone: "",
          }
        ],
        departments: [],
        documents: [
          {
            name: "",
            type: "",
            attachment: "",
            expiry_date: "",
            number: "",
            issue_date: "",
  
          }
        ],
        processesList:[],
        processos: [
          {
            type: "",
            attachment: "",
            start_date: "",
            end_date: "",
            description: "",
  
          }
        ],
        households: [],
        educations: [],
        work_experiences: [],
        work_experience: [
          {
            company_name: "",
            address: "",
            position: "",
            end_date: "",
            start_date: "",
  
  
          }
        ],
        employee: [{
          user: [{
            name: "",
          }],
          contacts: [
            {
              phone: "",
              id: "",
            },
  
          ]
        }],
  
        renewContract: [
          {
            type: "",
            expiry_date: "",
            start_date: "",
            renewals_number: 0,
          }
        ],
  
        contracts: [
          {
            type: "",
            renewals_number: 0,
            expiry_date: "",
            employee_id: "",
            status: "",
            cessar: "",
          }
        ],
        contract: {
          id: "",
          expiry_date: "",
          type: "",
          renewals_number: 0,
        },
        dependents: [],
        name: "",
        surname: "",
        activeTab: 0,
        dependet_birth_date: "",
        dependent_name: "",
        dependent_docNumber: "",
        selectedPosition: "",
        company_roles: [],
  
        deficiencies: [],
        contrato: [],
        deficiency: [{
          description: "",
          type: ""
        }],
        household: [{
          doc_type: "",
          name: "",
          kinship: "",
          doc_number: "",
          nuit: "",
          cell: "",
  
        }],
        dependent: [
          {
            birth_date: "",
            name: "",
            knship: "",
            doc_number: ""
          },
  
        ],
        dependent_doc_type: "",
        dependenteGrau: "",
        education: [
          {
  
          }
        ],
  
        input1: "",
        department_name: "",
        document_type: "BI",
  
        company_name: "",
        position: "",
        address: "",
        start_date: "",
        end_date: "",
  
  
        /////////EDITAR/////
        popupUpdateHouseHolds: false,
        popupUpdateDeficiency: false,
        popupUpdateAfiliados: false,
        popupUpdateEducations: false,
        popupUpdateWorkExperience: false,
        popupUpdateDocument: false,
  
        ficheiro: "",
        /////////Gravar/////
        popupAfiliados: false,
        popupActive: false,
        popupVerRenovacao: false,
        popupEducations: false,
        popupDocument: false,
        popupProcess: false,
        popupWorkExperience: false,
        popupHouseholds: false,
        popupDeficiency: false,
        popupContratos: false,
        popupRenovar: false,
        popupEstado: false,
        popupDetalhes: false,
        popupContactos: false,
        popupEditContactos: false,
  
  
        ficheiro1: "",
        ficheiro2: "",
        ficheiro3: "",
        ficheiro4: "",
        ficheiro5: "",
        ficheiro6: "",
        ficheiro7: "",
        ficheiro8: "",
        ficheiro10:"",
  
        course: "",
        school_name: "",
        conclusion_year: "",
        level: "",
        file: "",
        selectedDepartment: "",
  
        type: "",
        expiry_date: "",
        attachment: "",
        employee_id: "",
        number: "",
  
        imagem: "",
  
  
        responsabilities: [],
        inputs: [{
          component_id: [],
          amount: '',
        }],
        //   inputss: [{
        //   name: '',
        //   party: ''
        // }],
        responsability_names: [{
          responsability_name: '',
  
        }],
        responsible_id: "",
        employees: [
  
        ],
        subsidios: [],
        impostos: [],
        arrayObjSubsidio: [],
        arrayObjImposto: [],
        spouse: "",
        student: "",
        employee_structure: "",
        components: [],
        structure_components: [],
        popupEditSubsidio: false,
        popupUpdateProcess: false,
        dado: {
          pivot: {
            amount: "",
            id: ""
          }
        },
  
        err: "",
       
      }
    },
  
  
  
    async mounted() {
        this.getCurrentUser();
      await this.getData(),
        this.initialize()
  
    },
  
    methods: {
      initialize() {
  
        this.getDepartments(),
          this.getCompanyRoles(),
          
  
          // this.getEmployees(),
          this.getComponent(),
          this.getStructures()
  
      },

      getCurrentUser(){
      
      let authUser = localStorage.getItem('empId');
      var authUserObject = JSON.parse(authUser);

    
 
       this.userId = authUserObject.id;
    //    this.id = authUserObject.id;
  
    },
  
      popupOpenEditContacto(tr) {
        this.contacto = tr;
        this.popupEditContactos = true
  
  
      },
  
      async delete() {
  
        this.$vs.loading()
  
  
        let token = localStorage.getItem("token");
        let config = {
          headers: {
            authorization: "Bearer " + token,
          },
        };
  
  
  
        http
          .put(`/employees/disable/${this.employee.id}`, {}, config)
          .then((success) => {
            success;
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Sucesso",
              text: "Removido com sucesso!",
              color: "success",
              position: "top-right",
            })
            this.$router.push('/pages/employee/user-list');
          })
          .catch((error) => {
            error;
            this.err = error.response.data
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Erro",
              text: this.err,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            })
          });
        // }})
  
  
      },
 


  
  
  
  
  
  
  
      getStructures() {
  
        //    this.$vs.loading({
        //   container: '#div-with-loading',
        //   scale: 1.0,
        //   type:'sound'
        // })
  
  
        let token = localStorage.getItem("token");
        let config = {
          headers: {
            authorization: "Bearer " + token,
          },
        };
        http
          .get("/salaries/salary-structures/" + this.employee_structure, config)
          .then((result) => {
  
            // this.$vs.loading.close('#div-with-loading > .con-vs-loading')
  
            this.structure_components = result.data.salary_components
            this.structures = result.data
  
  
  
            // this.user = result.data.structure_employee.user
            // alert("2")
          })
          .catch((error) => {
            error;
  
            if (error.response.status == 401) {
              this.$router.push('/').catch(() => { })
            }
  
          });
      },
  
      getComponent() {
  
  
        let token = localStorage.getItem("token");
        let config = {
          headers: {
            authorization: "Bearer " + token,
          },
        };
  
        http
          .get("/salaries/components", config)
          .then((result) => {
            this.components = result.data.SalaryComponents
  
  
            ////////////////  FILTRAR SUBSIDIOS ////////////////////////////
            this.subsidios = this.components.filter((subsidio) => {
  
              if (subsidio.abbreviation != "INSS" && subsidio.abbreviation != "IRPS") {
  
                return subsidio
              }
            })
  
            ////////////////  FILTRAR IMPOSTOS ////////////////////////////
            this.impostos = this.components.filter((imposto) => {
  
              if (imposto.abbreviation == "INSS" || imposto.abbreviation == "IRPS") {
  
                return imposto
              }
            })
  
  
            this.arrayObjSubsidio = this.subsidios.map(item => {
  
              return {
                id: item.id,
                label: item.name
              };
            });
  
            this.arrayObjImposto = this.impostos.map(item => {
              return {
                id: item.id,
                label: item.name
              };
            });
            this.novo = this.components.map(d => d.responsability_name)
            // alert("2")
          })
          .catch((error) => {
            error;
  
            if (error.response.status == 401) {
              this.$router.push('/').catch(() => { })
            }
  
          });
      },
  
      openConfirm(componente) {
        this.componente = componente,
          this.$vs.dialog({
            type: 'confirm',
            color: 'danger',
            title: `Confirmação`,
            text: 'Tem certeza que deseja eliminar?',
            accept: this.cancel
          })
      },
  
 
  
  
      add() {
        this.inputs.push({
          component_id: '',
          amount: ''
        })
      },
  
      remove(index) {
        this.inputs.splice(index, 1)
      },
  
      addCandidate() {
  
        let token = localStorage.getItem("token");
        let config = {
          headers: {
            authorization: "Bearer " + token,
          },
        };
  
        const data = {
          name: 'Teste',
          component: JSON.stringify(this.inputs)
  
        };
  
        http
          .post("/salaries/salary-structures", data, config)
          .then((success) => {
            success;
            this.popupAdd = false,
  
              this.$vs.loading.close();
            this.$vs.notify({
              title: "Sucesso",
              text: "Estrutura salaria adicionado com sucesso!",
              color: "success",
              position: "top-right",
            })
          })
          .catch((error) => {
            error;
            this.err = error.response.data
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Erro",
              text: this.err,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            })
          });
  
      },
  
      previewImage(event) {
        this.attachment = event.target.files[0]
      },
  
      fileProcessos(event) {
        this.processos.attachment = event.target.files[0]
      },
  
  
      fileImageProfile(event) {
        this.imagem = event.target.files[0]
      },
  
      openUpdateProcess(process) {
        this.process = process;
        this.popupUpdateProcess = true
  
  
      },
  
      openUpdateDocument(document) {
        this.document = document;
        this.popupUpdateDocument = true
  
  
      },
  


  
   
 
  

      ///////////////////////////////////PROCESSOS//////////////////////////////////////
      async getProcesso() {
        this.$vs.loading()
  
        let token = localStorage.getItem("token");
        let config = {
          headers: {
            authorization: "Bearer " + token,
  
          },
        };
  
  
  
  
        this.$validator.validateAll();
        await http
          .get("/employees/processes",{}, config)
          .then((response) => {
            response;
            this.processos = response.data;
  
  
          })
          .catch((error) => {
            error;
  
          });
      },
  
  
  
  
  
      /////////////
  
      testar() {
        this.$vs.loading()
        let token = localStorage.getItem("token");
        let config = {
          headers: {
            authorization: "Bearer " + token,
            'content-type': "multipart/form-data"
          },
        };
       
  
        const data = new FormData();
        data.append('attachment', this.processos.attachment);
        data.append('description', this.processos.description);
        data.append("employee_id", this.$route.params.employeeId)
        data.append("start_date", this.processos.start_date)
        data.append("end_date", this.processos.end_date)
        data.append("type", this.processos.type)
         http
          .post("/employees/processes", data,config)
          .then((response) => {
        response
            
         
        
          })
          .catch((error) => {
            this.err = error.response.data
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Erro",
              text: this.err,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            })
          });
  
       
  },

  
      popupVerRenovacoes(data) {
        this.contract = data;
        this.popupVerRenovacao = true
  
  
      },
  

      getEmployees() {
        this.$vs.loading()
  
        let token = localStorage.getItem("token");
        let config = {
          headers: {
            authorization: "Bearer " + token,
          },
          params: {
            status: 1
          }
        };
  
        http
          .get("/employees/employees", config)
          .then((result) => {
            this.employees = result.data.Employees.reverse();
            this.$vs.loading.close()
          })
          .catch((error) => {
            this.$vs.loading.close()
            error;
  
          });
      },
  
      getDepartments() {
        let token = localStorage.getItem("token");
        let config = {
          headers: {
            authorization: "Bearer " + token,
          },
        };
  
        http
          .get("/companies/departments", config)
          .then((result) => {
            this.departments = result.data.Departments.reverse();
          })
          .catch((error) => {
            error;
  
          });
      },
  
  
  
      async saveDeficiency() {
        this.$vs.loading()
  
        let token = localStorage.getItem("token");
        let config = {
          headers: {
            authorization: "Bearer " + token,
          },
        };
  
        const data = {
          description: this.deficiency.description,
          type: this.deficiency.type,
          employee_id: this.$route.params.employeeId,
  
  
        };
  
        this.$validator.validateAll();
        await http
          .post("/employees/deficiencies", data, config)
          .then((success) => {
            success;
            this.getData()
            this.popupDeficiency = false,
              this.deficiency.description = "",
              this.deficiency.type = "",
              this.$vs.loading.close();
            this.$vs.notify({
              title: "Sucesso",
              text: "Deficiencia Adicionada com sucesso",
              color: "success",
              position: "top-right",
            })
          })
          .catch((error) => {
            error;
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Erro",
              text: "falha ao salvar Deficiencia",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            })
          });
      },
      async getData() {
        this.$router.push({ name: 'meu-perfil' })
        this.$vs.loading()
  
        let token = localStorage.getItem("token");
        let config = {
          headers: {
            authorization: "Bearer " + token,
          },
        };
  
  
        await http
          .get(`/employees/employees/${this.userId}`, config)
          .then((result) => {
            this.$vs.loading.close()
            this.documents = result.data.Employee.documents
            this.processesList = result.data.Employee.processes
            this.employee = result.data.Employee;
            this.dependents = result.data.Employee.dependents
            this.work_experiences = result.data.Employee.work_experiences
            this.educations = result.data.Employee.educations
            this.households = result.data.Employee.households
            this.deficiencies = result.data.Employee.deficiencies
            this.employee.contacts.phone = result.data.Employee.contacts[0].phone
            this.employee.contacts.id = result.data.Employee.contacts[0].id
            this.selectedDepartment = result.data.Employee.department
            this.selectedPosition = result.data.Employee.position
            this.contracts = result.data.Employee.contracts
            this.contacts = result.data.Employee.contacts
            this.employee_structure = result.data.Employee.employee_structure[0].id
            
  
  
          })
          .catch((error) => {
            error
            this.$vs.loading.close();
          });
      },
  
  
  
      async EditEmployee() {
        this.$vs.loading()
  
        let token = localStorage.getItem("token");
        let config = {
          headers: {
            authorization: "Bearer " + token,
          },
        };
  
        const data = {
          user_id: this.employee.user.id,
          inss: this.employee.inss,
          nuit: this.employee.nuit,
          name: this.employee.user.name,
          surname: this.employee.user.surname,
          email: this.employee.user.email,
          phone: this.employee.contacts.phone,
          contact_id: this.employee.contacts.id,
          birth_date: this.employee.birth_date,
          marital_status: this.employee.marital_status,
          gender: this.employee.gender,
          address: this.employee.address,
          nationality: this.employee.nationality,
          basic_salary: this.employee.basic_salary,
          document_type: this.employee.document_type,
          document_number: this.employee.document_number,
          position_id: this.selectedPosition.id,
          department_id: this.selectedDepartment.id,
  
  
        };
  
        this.$validator.validateAll();
        await http
          .put(`/employees/employees/${this.$route.params.employeeId}`, data, config)
          .then((success) => {
            success;
            this.popupWorkExperience = false,
              this.$vs.loading.close();
            this.$vs.notify({
              title: "Sucesso",
              text: "Utilizador actualizado com sucesso",
              color: "success",
              position: "top-right",
            })
          })
          .catch((error) => {
            error;
            if (error.response.status == 422) {
              this.$vs.loading.close();
              this.err = error.response.data
              this.$vs.notify({
                title: "Erro",
                text: this.err,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-right",
              })
            } else {
              this.$vs.loading.close();
              this.$vs.notify({
                title: "Erro",
                text: "Aconteceu algum erro",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-right",
              })
            }
  
          });
      },
  
  
  
  
    },
    watch: {
      //   currentUser() {
      //       this.verifyPermissions()
      // }
    }
  
  }
  
  </script>
  